{
  "CxiLicenceType_SOLO": "Solo",
  "CxiLicenceType_TEAMS": "Equipes",
  "CxiLicenceType_UNITE": "Unir",
  "CxiLicenceType_NONE": "Nenhum",
  "NAME": "CxiLicenceTypes"
}